export const INVALID_PIN_ERROR_MESSAGE =
  'We don’t recognize that. Please try again.';
export const TIMED_OUT_PIN_ERROR_MESSAGE = 'Your code has timed out.';
export const DEFAULT_PIN_INFO_MESSAGE = "Didn't receive your code?";
export const INVALID_CODE_RESPONSE_MESSAGE = 'Invalid code.';
export const TIMED_OUT_CODE_RESPONSE_MESSAGE = 'Code has expired.';
